import { render, staticRenderFns } from "./relogioDigital.vue?vue&type=template&id=3191f8ea&scoped=true&"
import script from "./relogioDigital.vue?vue&type=script&lang=js&"
export * from "./relogioDigital.vue?vue&type=script&lang=js&"
import style0 from "./relogioDigital.vue?vue&type=style&index=0&id=3191f8ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3191f8ea",
  null
  
)

export default component.exports